import React, { Fragment } from 'react';

import { Button } from 'components/ui/Button';

import { Lightning } from 'components/svg/Lightning';

import { colors, Fonts, spacing } from 'styles/theme';
import { Card, Divider, Bumper, HorizontalFlexWrapper } from 'styles/shared';

export interface ActionItemProps {
    text: string;
    onClick: () => void;
}

interface ActionCardProps {
    actionItems: Array<ActionItemProps>;
}

export const ActionCard = ({ actionItems }: ActionCardProps) => {
    return (
        <Card $width="236px" $padding={spacing.large}>
            <HorizontalFlexWrapper $isMarginAuto>
                <Lightning color={colors.mountainAsh} />
                <Bumper $minWidth={spacing.xxSmall} />
                <Fonts.Medium
                    $color={colors.mountainAsh}
                    $isOpenSansSemiBold
                >{`Take Action`}</Fonts.Medium>
            </HorizontalFlexWrapper>
            <Divider />
            {actionItems.map(({ text, onClick }, index) => (
                <Fragment key={text}>
                    <Button
                        key={text}
                        onClick={onClick}
                        $style="ghost"
                        $isStretch
                        $isSmall
                    >
                        {text}
                    </Button>
                    {index + 1 === actionItems.length ? null : (
                        <Bumper $minHeight={spacing.xSmall} />
                    )}
                </Fragment>
            ))}
        </Card>
    );
};
